<script setup lang="ts">
import { formatCurrency } from '~/composables/format-currency';

defineProps<{
  amount: number;
}>();

const TOOLTIP_TEXT =
  "This fee helps run the platform and covers payment processing. It's shown before you commit, and is non-refundable.";
</script>

<template>
  <div
    class="d-flex justify-space-between text-body-2 text-medium-emphasis service-fee-line"
  >
    <span class="d-inline-flex align-center">
      <span>Service fee</span>
      <v-tooltip :text="TOOLTIP_TEXT" location="top" max-width="320">
        <template #activator="{ props: tooltipProps }">
          <NuxtLink
            v-bind="tooltipProps"
            to="/help#service-fee"
            target="_blank"
            rel="noopener"
            aria-label="Learn more about the service fee"
            class="service-fee-info-link ml-1 d-inline-flex align-center"
          >
            <v-icon size="x-small" color="medium-emphasis">
              mdi-information-outline
            </v-icon>
          </NuxtLink>
        </template>
      </v-tooltip>
    </span>
    <span>{{ formatCurrency(amount) }}</span>
  </div>
</template>

<style scoped>
.service-fee-info-link {
  color: inherit;
  text-decoration: none;
  line-height: 1;
}
.service-fee-info-link:hover,
.service-fee-info-link:focus-visible {
  opacity: 0.8;
}
</style>
